import React from "react";
import RuleGraphSigma from "@/components/RuleGraphSigma/RuleGraphSigma";
import { useGraphVisualisation } from "../hooks/useGraphVisualisation";
import { boundedView } from "../decisionGraphView";

// The force layout draws every node it's given: past this many, it gets the ones nearest the goal
const NEBULA_NODE_LIMIT = 20000;

const Nebula = () => {
  const { graph, visible, goal, setSelectedNodeId } = useGraphVisualisation();
  const rawGraph = React.useMemo(
    () => (graph ? graph.filterByNodes([...boundedView(graph, visible, goal, NEBULA_NODE_LIMIT)].filter(id => graph.isListed(id))) : null),
    [graph, visible, goal],
  );
  if (!rawGraph) return null;
  return (
    <RuleGraphSigma
      rawGraph={rawGraph}
      onNodeClick={setSelectedNodeId}
    />
  );

}
export default Nebula;
